import { render, staticRenderFns } from "./BiodataDetails.vue?vue&type=template&id=0eb0d050&"
import script from "./BiodataDetails.vue?vue&type=script&lang=js&"
export * from "./BiodataDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports